// 单文件引入方式

import SelectorField from './ZuiSelectorField.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSelectorField', SelectorField)
  }
}

export { SelectorField }
